import React, { useState } from 'react'
import { Link } from "react-router-dom"
import PageHeader from '../../components/layout_components/PageHeader'
import StyledButton from '../../components/layout_components/StyledButtonToggle'
import Layout from '../../layout'
import { toTitleCase } from '../../services/helpers/helpers'

import bannerArt from "../../assets/media/pricing/bannerArt.png"
import ControlledAccordions from '../../components/pages_components/pricing_page_components/Accordion'
import PriceCards from '../../components/pages_components/pricing_page_components/PriceCards'
import FeaturesTable from '../../components/pages_components/pricing_page_components/FeaturesTable'
import "./style.css"
import DataFeatureTable from '../../components/pages_components/pricing_page_components/DataFeatureTable'

const Pricing = () => {

    const [isMonthlyPlanActive, setIsMonthlyPlanActive] = useState(true)
    const [isYearlyPlanActive, setIsYearlyPlanActive] = useState(false)

    const toggleMonthlyPlan = () => {
        setIsMonthlyPlanActive(true)
        setIsYearlyPlanActive(false)
    }

    const toggleYearlyPlan = () => {
        setIsMonthlyPlanActive(false)
        setIsYearlyPlanActive(true)
    }


    const faqs = [
        {
            title: "How do I get started?",
            desc: "Pick a plan that serves your requirement, share your details to create and launch your gamified test."
        },
        {
            title: "Is integration possible with applicant tracking system(s)?",
            desc: "Our platform can be integrated with leading Applicant Tracking Systems (ATS) like Oracle, SAP.iO, etc."
        },
        {
            title: "What is a free trial?",
            desc: "A free trial is offered to you to get familiarized with our platform. There is no risk involved, no obligation and no credit card payment needed."
        },
        {
            title: "What is your pricing model?",
            desc: "We have two different pricing models. You either pay on a Quarterly basis (3-month) or Annually (12-month)."
        },
        {
            title: "What payment method works?",
            desc: "We accept payments through all leading credit cards."
        },
        {
            title: "When do I get charged?",
            desc: "We use post-billing method and charge in arrears. Invoices are issued the next day you buy a plan."
        },
        {
            title: "What is the data privacy or storage policy?",
            desc: "Our platform and games are hosted on Amazon Web Services (AWS) – one of the most secured cloud servers. We have strict security protocols in place and we are GDPR & EU Data Policy Compliant."
        },
        {
            title: "What is the difference between assessment and game?",
            desc: "An assessment is just a competency and a game is a whole package. You can create a game with multiple assessments. We mainly have assessments like Cognitive Ability Assessments, Competency-based Assessments and Aptitude Assessments."
        },

    ]

    return (
        <Layout>
            <div className="pricing">
                <div className="pricingWrapper">
                    <div className="pageHeader my-10 w-[20rem] sm:w-[40rem] lg:w-[90vw] mx-auto">
                        <PageHeader titleText={"Transparent Prices, No Surprises"} customStyleImage="mt-2 w-[20rem]" />
                        <p className='font-light text-center text-sm 2xl:mt-10 2xl:text-[20px]'>No Contracts. No Surprise fees.</p>
                    </div>

                    {/* pricing component */}
                    <div className="pricingComponent w-[20rem] sm:w-[40rem] lg:w-[90vw] mx-auto">
                        {/* it will be disbaled untill quaterly pricning added */}
                        <div className="pricingHeader flex justify-center bg-[#F0F0F0] border-2 border-[#DCDCDC] w-full sm:w-fit mx-auto px-1 py-1 rounded-full">
                            <StyledButton cClassName="toggle" btnEventHandler={toggleMonthlyPlan} btnText={"Quarterly"} customStyle={` font-semibold ${isMonthlyPlanActive === true ? '!text-[#333333] !bg-[#FFD700] hover:!text-[#333333] hover:!bg-[#FFD700]' : '!text-[#333333] !bg-[#F0F0F0] hover:!text-[#333333] hover:!bg-[#F0F0F0]'} `} />

                            <StyledButton cClassName="toggle" btnEventHandler={toggleYearlyPlan} btnText={"Annually"} customStyle={`font-semibold ${isYearlyPlanActive === false ? '!text-[#333333] !bg-[#F0F0F0] hover:!text-[#333333] hover:!bg-[#F0F0F0]' : '!text-[#333333] !bg-[#FFD700] hover:!text-[#333333] hover:!bg-[#FFD700]'}`} btnDisabled={false} />
                        </div>
                        {isMonthlyPlanActive && <PriceCards plan="quarter" />}
                        {isYearlyPlanActive && <PriceCards plan="year" />}
                    </div>
                    {/* pricing component end */}


                    {/* features component start */}
                    <FeaturesTable />
                    {/* features component end */}

                    {/* DataFeatureTable start */}
                    <div className="hidden lg:block pageHeader my-20 w-[20rem] sm:w-[40rem] lg:w-[90vw] mx-auto">
                        <PageHeader titleText={"Data Collection Fields Within Gamified Tests"} customStyleImage="mt-2 w-[20rem]" />
                    </div>
                    <DataFeatureTable  plan="quarter" />
                    {/* DataFeatureTable end */}


                    {/* faq section starts */}
                    <div className="faqSection 2xl:mt-20">
                        <div className="pageHeader my-10 w-[20rem] sm:w-[40rem] lg:w-[80vw] mx-auto xl:w-[90vw]">
                            <PageHeader titleText={"Frequently Asked Questions"} customStyleImage="my-2 w-[20rem]" customStyleContainer={"!my-12"} />
                            <div className="accrdions w-[20rem] sm:w-[40rem] lg:w-[50rem]  xl:w-[60rem] flex flex-wrap justify-around mx-auto 2xl:w-[85rem]  ">

                                {
                                    faqs.map((faq, faqIndex) => (

                                        <div key={`divFaqIndex${faq.title + faqIndex}`} className="accrordion my-2 w-full lg:w-[20rem] xl:w-[24rem] sm:w-[18rem] sm:m-1 lg:my-2 2xl:w-[35rem] 2xl:my-4">
                                            <ControlledAccordions title={faq.title} desc={faq.desc} />
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                    </div>
                    {/* faq section end */}



                    {/* banner starts */}
                    <div className="innerB  bg-[#333333] lg:mt-40 xl:mt-40 mt-36">

                        <div className="innerBWrapper h-[390px] sm:h-full lg:h-[14rem]  relative   py-10 flex justify-center lg:justify-between lg:w-[80vw] lg:mx-auto 2xl:h-[346px]">

                            <div className="left  w-full flex flex-col-reverse items-center lg:items-start sm:w-[40rem] lg:w-[30rem] 2xl:w-[682px] lg:justify-center">
                                <div className="wrapper flex flex-col items-center lg:items-start">

                                    <h4 className='text-[#FFD700]  text-[24px] sm:text-2xl font-bold text-center lg:text-left lg:text-[30px] lg:leading-[36px] xl:text-[34px] xl:leading-[45px] 2xl:text-[44px] 2xl:leading-[55px]'>{toTitleCase("Attracting & HIRING TOP TALENT WASN'T THIS EASY")}</h4>
                                    <Link to={"/free"}>

                                        <StyledButton btnText={"START FREE TRIAL"} customStyle="!bg-[#FFD700] !text-[#333333] !mt-4 sm:!mt-5 !h-[45px] !p-6 xl:w-[15rem] xl:!font-semibold font-bold 2xl:w-[20rem] lg:!mt-10 xl:text-xs xl:h!-[2rem] xl:font-bold xl:!p-0 2xl:!h-[3.5rem] hover:!bg-white hover:!text-[#333333] hover:!font-semibold 2xl:hover:!bg-white 2xl:hover:!text-[#333333] xl:hover:!bg-white xl:hover:!text-[#333333] xl:hover:!font-semibold lg:hover:!bg-white lg:hover:!text-[#333333] lg:hover:!font-semibold" />

                                    </Link>
                                </div>
                            </div>
                            <div className="right visible sm:invisible lg:visible">
                                <img src={bannerArt} className="sm:object-contain h-[350px] w-[432px] sm:h-[16rem] lg:h-[400px] lg:w-[500px] lg:-top-[7.5rem] absolute -top-32 right-0  sm:-top-10 sm:right-40 xl:h-[500px] xl:w-[600px] 2xl:h-[600px] 2xl:w-[700px] xl:-top-[9rem] 2xl:-top-36 2xl:-right-40 xl:-right-[94px] lg:-right-[97px]" alt="" />
                            </div>
                        </div>

                    </div>

                    {/* banner end */}

                    {/* page end */}

                    <div className="pageEnd">

                        <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '10rem', width: '100%' }}><path d="M-3.76,53.79 C161.02,147.54 334.84,150.50 500.00,49.99 L500.00,0.00 L0.00,0.00 Z" style={{ stroke: 'none', fill: '#F7F7F7' }} /></svg>
                    </div>


                </div>
            </div>
        </Layout>
    )
}

export default Pricing